import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  deleteLoadIndicatorAction,
  editLoadIndicatorAction,
  loadIndicatorListAction
} from "../../../../../../modules/loadnoindicator/action";
import TabHeaderAndButton from "../../../../../Common/TabHeaderAndButton";
import CreateTable from "../../../../../CreateTable";
import ConfirmationDialog from "../../../../../FormElement/ConfirmationDialog";
import Loader from "../../../../../Loader";

class LoadNoIndicatorView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      headerRows: {
        updatedAt: "Last Updated",
        updatedBy: "Updated By",
        type: "Load Number Indicator Type",
        code: "Load Number Indicator Code"
      },
      order: "desc",
      orderBy: "id",
      open: false
    };
  }

  componentDidMount() {
    const id = localStorage.getItem("currentFieldGrpId");
    const { loadIndicatorListAction, selectedYear, selectedGrp } = this.props;
    loadIndicatorListAction(id, selectedYear, selectedGrp.id);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.rowLoadList &&
      this.props.rowLoadList !== nextProps.rowLoadList &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
    if (
      nextProps.selectedYear &&
      nextProps.selectedYear !== this.props.selectedYear
    ) {
      this.props.loadIndicatorListAction(
        "",
        nextProps.selectedYear,
        this.props.selectedGrp.id
      );
    }
  }

  deleteRow = id => {
    this.setState({
      open: true,
      id: id
    });
  };

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleOk = () => {
    const { id } = this.state;
    this.handleClose();
    this.props.deleteLoadIndicatorAction(id);
  };

  editRow = id => {
    const { rowLoadList } = this.props;
    const requiredData = rowLoadList.find(load => load.id === id);
    console.log(requiredData);
    this.props.editLoadIndicatorAction(requiredData);
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  render() {
    const { rowLoadList } = this.props;
    const { fetchingComplete, order, orderBy, open } = this.state;
    const prevPath = "farmsetup/farminformation/field-groups",
      currentPage = "/indicators";
    return (
      <div className="ticket-body">
        <ConfirmationDialog
          open={open}
          handleClose={this.handleClose}
          handleOk={this.handleOk}
        />
        <TabHeaderAndButton
          header="Load Number Indicators"
          path={`/${prevPath}${currentPage}/create`}
          btnLabel="Add load number indicator"
        />
        <div>
          {fetchingComplete ? (
            <CreateTable
              order={order}
              orderBy={orderBy}
              headerRows={this.state.headerRows}
              rowData={rowLoadList}
              delete={this.deleteRow}
              location={`${prevPath}${currentPage}/edit`}
              edit={this.editRow}
              onRequestSort={this.handleRequestSort}
            />
          ) : (
            <Loader />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    rowLoadList: state.loadReducer.loadList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    selectedYear: state.harvestYearReducer.selectedYear,
    selectedGrp: state.fieldGroupReducer.selectedGrp
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadIndicatorListAction,
      deleteLoadIndicatorAction,
      editLoadIndicatorAction
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadNoIndicatorView);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/FieldGroups/LoadNumberIndicators/LoadNoIndicatorView.js